import { SET_ACTIVE_TAB, SET_IS_SIDENAV_OPEN } from './reducer';

export const setActiveTab = (payload) => ({
  type: SET_ACTIVE_TAB,
  payload,
});
export const setGlobalSideNavOpen = (payload) => ({
  type: SET_IS_SIDENAV_OPEN,
  payload,
});
